module.exports = __webpack_public_path__ + "media/images/story_ranking_mailer/rank_no5-3f298f37b67d0e77eefef3b954bc9a1d.png";